import moment from 'moment-timezone'

export const computeLessonTime = (startTime, endTime) => {
	const start = moment(startTime)
	const end = moment(endTime)
	return moment(end).diff(start, 'minutes')
}
